import { NgClass, NgOptimizedImage } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductAttr, ProductAttrValue } from '../../../models/product';
import { FileurlPipe } from '../../../pipes/fileurl.pipe';

@Component({
  selector: 'app-product-attr-value-select',
  imports: [NgOptimizedImage, FileurlPipe, NgClass],
  templateUrl: './product-attr-value-select.html',
  styleUrl: './product-attr-value-select.scss',
})
export class ProductAttrValueSelect {
  @Input({ required: true }) attr!: ProductAttr;
  @Input() activeValue?: ProductAttrValue;
  @Output() activeValueChange = new EventEmitter<ProductAttrValue>();

  select(value: ProductAttrValue) {
    this.activeValue = value;
    this.activeValueChange.emit(value);
  }
}
